<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'common.name' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.campaignActionDto[0].name}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.emissionStartDate' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.campaignActionDto[0].start_date}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.emissionEndDate' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.campaignActionDto[0].end_date}}
  </div>
</div>
<div class="ui-g-12 ui-md-6" *ngIf="touchPointOfflineList.length > 0">
  <div class="label ui-g-12 ui-md-6"> {{ 'promotion.touchPoints' | translate }} Offline: </div>
  <div class="touchpoint ui-g-12" *ngFor="let touchpoint of touchPointOfflineList; let i = index">
    {{touchpoint.label}}
  </div>
</div>
<div class="ui-g-12 ui-md-6" *ngIf="touchPointOnlineList.length > 0">
  <div class="label ui-g-12 ui-md-6"> {{ 'promotion.touchPoints' | translate }} Online: </div>
  <div class="ui-g-12 ui-md-6">
    <div class="touchpoint ui-g-12" *ngFor="let touchpoint of touchPointOnlineList; let i = index">
      {{touchpoint.label}}
    </div>
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.distributionList' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.campaignDistributionListDto[0].name}}
  </div>
</div>
<div class="ui-g-12 ui-md-6"
  *ngIf="isMessageInstancePresent && viewActionGenerated.messageInstanceDto[0].codice_articolo">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.itemCode' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].codice_articolo}}
  </div>
</div>
<div class="ui-g-12 ui-md-6" *ngIf="isMessageInstancePresent && viewActionGenerated.messageInstanceDto[0].barcode">
  <div class="label ui-g-12 ui-md-6"> {{ 'promotion.barCode' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].barcode}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.communicationType' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.campaignActionDto[0].message_description}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'store.typePromo' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].name}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.couponValue' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].discount_amt}}
  </div>
</div>
<div class="ui-g-12 ui-md-6"
  *ngIf="isMessageInstancePresent && viewActionGenerated.messageInstanceDto[0].threshold_value">
  <div class="label ui-g-12 ui-md-6"> {{ 'promotion.thresholdValue' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].threshold_value}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.couponUseNumber' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].coupon_use_number}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.dynamicCoupon' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{dynamicCoupon}}
  </div>
</div>
<div class="ui-g-12 ui-md-6" *ngIf="isBasketPresent">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.itemBasket' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.basketDto[0].description}}
  </div>
</div>
<div class="ui-g-12 ui-md-6" *ngIf="isCampaignConstraintExclusionPresent">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.typeExclusion' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.campaignConstraintEsclusionDto[0].name}}
  </div>
</div>
<div class="ui-g-12 ui-md-6" *ngIf="isCampaignConstraintValidationPresent">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.otherConstraints' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.campaignConstraintValidationDto[0].name}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.fruitionStartDate' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].start_fruition_date}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.fruitionEndDate' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{viewActionGenerated.messageInstanceDto[0].end_fruition_date}}
  </div>
</div>
<div class="ui-g-12 ui-md-6"
  *ngIf="isMessageInstancePresent && viewActionGenerated.messageInstanceDto[0].card_holder_type">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.cardNecessary' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{cardHolderType}}
  </div>
</div>
<div class="ui-g-12 ui-md-6">
  <div class="label ui-g-12 ui-md-6"> {{ 'campaign.actionStatus' | translate }}: </div>
  <div class="ui-g-12 ui-md-6">
    {{actionStatus}}
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-action-details/campaign-action-details.component.html